"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layout = _interopRequireDefault(require("./layout.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Layout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Layout, _React$Component);

  function Layout(props) {
    var _this;

    _classCallCheck(this, Layout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Layout).call(this, props));
    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Layout, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var open = this.state.open;
      var _this$props = this.props,
          children = _this$props.children,
          logo = _this$props.logo,
          partials = _this$props.partials,
          sections = _this$props.sections;
      var Content = partials.Content,
          Sidebar = partials.Sidebar,
          SidebarToggle = partials.SidebarToggle;
      return _react["default"].createElement("div", {
        className: "".concat(_layout["default"]['layout'], " ").concat(open ? _layout["default"]['open'] : '')
      }, _react["default"].createElement("div", {
        className: _layout["default"]['layout-toggle']
      }, _react["default"].createElement(SidebarToggle, {
        onClick: function onClick() {
          return _this2.setState({
            open: !open
          });
        }
      })), _react["default"].createElement("div", {
        className: _layout["default"]['layout-scrim'],
        onClick: function onClick() {
          return _this2.setState({
            open: false
          });
        }
      }), _react["default"].createElement("div", {
        className: _layout["default"]['layout-sidebar']
      }, _react["default"].createElement(Sidebar, {
        logo: logo,
        open: open
      })), _react["default"].createElement("div", {
        className: _layout["default"]['layout-content']
      }, _react["default"].createElement(Content, null, children)));
    }
  }]);

  return Layout;
}(_react["default"].Component);

Layout.propTypes = {
  sections: _propTypes["default"].array
};
Layout.defaultProps = {
  sections: []
};
var _default = Layout;
exports["default"] = _default;